"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _SnetFooterColumns = _interopRequireDefault(require("./SnetFooterColumns"));
var _SnetFooterCopyright = _interopRequireDefault(require("./SnetFooterCopyright"));
var _SnetFooterModule = _interopRequireDefault(require("./SnetFooter.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SnetFooter = () => {
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: _SnetFooterModule.default.snetFooterContainer
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: _SnetFooterModule.default.snetFooter
  }, /*#__PURE__*/_react.default.createElement(_SnetFooterColumns.default, null), /*#__PURE__*/_react.default.createElement(_SnetFooterCopyright.default, null)));
};
var _default = exports.default = SnetFooter;